module.exports = __webpack_public_path__ + "static/media/plan-payment.7a5d25c3.svg";